import React from 'react';
import { ThemeProvider } from 'styled-components';
import { IntlProvider } from 'react-intl';
import { styles } from '@sdir/sds';
import { SdirAuthProvider } from '@sdir/auth/lib/providers';
import { SdirAuthProviderProps } from '@sdir/auth/lib/providers/SdirAuthProvider';
import messages from '../../localization/localization';
import { ReporteesProvider } from './ReporteesProvider';

interface InputProps {
  children: any;
}

const Providers: React.FC<InputProps> = ({ children }) => {
  const lang = window.location.pathname?.split('/')?.includes('no') ? 'no' : 'en';

  const authSettings: SdirAuthProviderProps = {
    authenticationSettings: {
      client_id: process.env.REACT_APP_CLIENT_ID as string,
      client_secret: process.env.REACT_APP_CLIENT_SECRET as string,
      scope: process.env.REACT_APP_SCOPE as string,
      extraQueryParams: { securitylevel: '4' },
    },
  };

  return (
    <SdirAuthProvider {...authSettings}>
      <IntlProvider locale={lang} messages={messages[lang as keyof typeof messages]}>
        <ThemeProvider theme={styles}>
          <ReporteesProvider>{children}</ReporteesProvider>
        </ThemeProvider>
      </IntlProvider>
    </SdirAuthProvider>
  );
};

export default Providers;
